(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-contents"] && !Shopify.designMode) return;
  try {
    // Cart actions for the cart page and the drawer (delegated: the drawer's contents are
  // re-rendered after each change). The drawer re-renders itself; the cart page reloads.
  (function () {
    var PC = window.PlayCart = window.PlayCart || {};
    if (PC.contentsBound) return;
    PC.contentsBound = true;

    function request(url, body) {
      return fetch(url, {
        method: body ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined
      }).then(function (r) {
        if (!r.ok) throw new Error(url + ' ' + r.status);
        return r.json();
      });
    }

    function done(root) {
      if (root && root.dataset.context === 'drawer' && PC.refresh) return PC.refresh();
      window.location.reload();
    }

    function act(root, work) {
      root.classList.add('is-busy');
      work.then(function () { done(root); }, function (err) {
        console.error('Cart update failed:', err);
        done(root);
      });
    }

    function lines(root) {
      return Array.prototype.slice.call(root.querySelectorAll('.cart-item[data-line-key]'));
    }

    function removeKeys(keys) {
      var updates = {};
      keys.forEach(function (key) { updates[key] = 0; });
      return request('/cart/update.js', { updates: updates });
    }

    // A line goes with the gift set that was added with its magnets.
    function removeLine(root, item) {
      var keys = [item.dataset.lineKey];
      var group = item.dataset.giftGroup;
      if (group) {
        lines(root).forEach(function (i) { if (i.dataset.giftFor === group) keys.push(i.dataset.lineKey); });
      }
      return removeKeys(keys);
    }

    // One magnet of a line: the line keeps the others, renumbered (_magnet_N_*), one fewer.
    function removeMagnet(root, item, n) {
      return request('/cart.js').then(function (cart) {
        var line = cart.items.filter(function (i) { return i.key === item.dataset.lineKey; })[0];
        if (!line) return null;
        if (line.quantity <= 1) return removeLine(root, item);
        var props = {};
        var re = /^_magnet_(\d+)_(.+)$/;
        Object.keys(line.properties || {}).forEach(function (key) {
          var m = re.exec(key);
          if (!m) { props[key] = line.properties[key]; return; }
          var i = parseInt(m[1], 10);
          if (i === n) return;
          props['_magnet_' + (i > n ? i - 1 : i) + '_' + m[2]] = line.properties[key];
        });
        if (props._bundle_qty) props._bundle_qty = String(line.quantity - 1);
        return request('/cart/change.js', { id: line.key, quantity: line.quantity - 1, properties: props });
      });
    }

    // The gift set belongs to the magnets: link it to the first personalised line (_gift_group
    // on the magnets, _gift_for on the set), as the customizer does.
    function addGiftSet(variantId) {
      return request('/cart.js').then(function (cart) {
        var magnet = cart.items.filter(function (i) {
          return i.properties && (i.properties._bundle_qty || i.properties._magnet_1_preview);
        })[0];
        if (!magnet) return request('/cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
        var group = magnet.properties._gift_group;
        var linked = Promise.resolve();
        if (!group) {
          group = 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
          var props = Object.assign({}, magnet.properties, { _gift_group: group });
          linked = request('/cart/change.js', { id: magnet.key, quantity: magnet.quantity, properties: props });
        }
        return linked.then(function () {
          return request('/cart/add.js', { items: [{ id: variantId, quantity: 1, properties: { _gift_for: group } }] });
        });
      });
    }

    // A gift set whose magnets are gone goes too, however they were removed.
    PC.cleanOrphans = function (root) {
      if (!root) return false;
      var all = lines(root);
      var groups = all.map(function (i) { return i.dataset.giftGroup; }).filter(Boolean);
      var orphans = all.filter(function (i) { return i.dataset.giftFor && groups.indexOf(i.dataset.giftFor) < 0; });
      if (!orphans.length) return false;
      act(root, removeKeys(orphans.map(function (i) { return i.dataset.lineKey; })));
      return true;
    };

    document.addEventListener('click', function (e) {
      var root = e.target.closest && e.target.closest('[data-cart-contents]');
      if (!root) return;
      var t;
      if ((t = e.target.closest('[data-cart-remove-magnet]'))) {
        e.preventDefault();
        act(root, removeMagnet(root, t.closest('.cart-item'), parseInt(t.dataset.cartRemoveMagnet, 10)));
      } else if ((t = e.target.closest('[data-cart-remove]'))) {
        e.preventDefault();
        act(root, removeLine(root, t.closest('.cart-item')));
      } else if ((t = e.target.closest('.cart-item__qty-btn'))) {
        if (t.classList.contains('is-active')) return;
        act(root, request('/cart/change.js', { id: t.closest('.cart-item').dataset.lineKey, quantity: parseInt(t.dataset.qty, 10) }));
      } else if ((t = e.target.closest('[data-cart-addon]'))) {
        var id = parseInt(t.dataset.variantId, 10);
        act(root, t.dataset.cartAddon === 'gift' ? addGiftSet(id) : request('/cart/add.js', { items: [{ id: id, quantity: 1 }] }));
      }
    });

    function cleanPage() {
      PC.cleanOrphans(document.querySelector('[data-cart-contents][data-context="page"]'));
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cleanPage);
    else cleanPage();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["magnet-addons"] && !Shopify.designMode) return;
  try {
    (function () {
    var params = new URLSearchParams(window.location.search);

    document.querySelectorAll('[data-addon]').forEach(function (row) {
      var check = row.querySelector('[data-addon-check]');
      var qtyBox = row.querySelector('[data-addon-qty]');
      var count = row.querySelector('[data-addon-count]');
      var minus = row.querySelector('[data-addon-minus]');
      var plus = row.querySelector('[data-addon-plus]');
      var max = parseInt(row.dataset.max, 10) || 10;

      function setQty(n) {
        n = Math.max(1, Math.min(max, n));
        row.dataset.qty = String(n);
        count.textContent = n;
        minus.disabled = n <= 1;
        plus.disabled = n >= max;
      }

      function sync() {
        qtyBox.hidden = !check.checked;
        row.classList.toggle('is-on', check.checked);
      }

      minus.addEventListener('click', function () { setQty(parseInt(row.dataset.qty, 10) - 1); });
      plus.addEventListener('click', function () { setQty(parseInt(row.dataset.qty, 10) + 1); });
      check.addEventListener('change', sync);

      // Coming from the homepage gift card: start with the gift set ticked.
      if (row.dataset.addonKind === 'gift' && params.get('gift') === '1') check.checked = true;
      setQty(1);
      sync();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["occasion-lightbox"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__occasionLightboxReady) return;
    window.__occasionLightboxReady = true;

    var lastFocused = null;

    function box() { return document.querySelector('[data-occasion-lightbox]'); }

    function open(card) {
      var lb = box();
      if (!lb) return;

      var img   = lb.querySelector('[data-occasion-lightbox-img]');
      var art   = lb.querySelector('[data-occasion-lightbox-art]');
      var emoji = lb.querySelector('[data-occasion-lightbox-emoji]');
      var title = lb.querySelector('[data-occasion-lightbox-title]');
      var src   = card.getAttribute('data-occasion-image');
      var label = card.getAttribute('data-occasion-label') || '';

      title.textContent = label;

      if (src) {
        img.onload = function () {
          if (img.naturalWidth) {
            img.width = img.naturalWidth;
            img.height = img.naturalHeight;
          }
        };
        img.src = src;
        img.alt = label;
        img.hidden = false;
        art.hidden = true;
      } else {
        // No photo uploaded yet — show the card artwork enlarged instead
        img.hidden = true;
        img.removeAttribute('src');
        art.style.background = card.getAttribute('data-occasion-gradient') || '#eeeeee';
        emoji.textContent = card.getAttribute('data-occasion-emoji') || '';
        art.hidden = false;
      }

      lastFocused = document.activeElement;
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
      var closeBtn = lb.querySelector('[data-occasion-lightbox-close]');
      if (closeBtn && closeBtn.focus) closeBtn.focus();
    }

    function close() {
      var lb = box();
      if (!lb || lb.hidden) return;
      lb.hidden = true;
      document.body.style.overflow = '';
      if (lastFocused && lastFocused.focus) lastFocused.focus();
      lastFocused = null;
    }

    document.addEventListener('click', function (e) {
      var card = e.target.closest ? e.target.closest('[data-occasion-card]') : null;
      if (card) {
        e.preventDefault();
        open(card);
        return;
      }
      if (e.target.closest && e.target.closest('[data-occasion-lightbox-close]')) {
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') close();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["other-designs"] && !Shopify.designMode) return;
  try {
    // Carry ?qty= and ?gift= over to the other designs' links.
  (function () {
    function carry() {
      var current = new URLSearchParams(window.location.search);
      var keep = new URLSearchParams();
      ['qty', 'gift'].forEach(function (key) {
        if (current.get(key)) keep.set(key, current.get(key));
      });
      var query = keep.toString();
      if (!query) return;
      document.querySelectorAll('[data-other-design]').forEach(function (link) {
        link.href = link.pathname + '?' + query;
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', carry);
    else carry();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rebrand-popup"] && !Shopify.designMode) return;
  try {
    // Shows the rebrand popup once, only for visitors from the old domain (?from=muzikalnaplocha),
  // and again right after its newsletter form was sent (to show the result).
  (function () {
    var KEY = 'ptn-rebrand-seen';
    var params = new URLSearchParams(window.location.search);
    var fromOld = params.get('from') === 'muzikalnaplocha';
    var afterSignup = params.get('customer_posted') === 'true' || window.location.hash === '#rebrand-newsletter';
    if (!fromOld && !afterSignup) return;

    function seen() { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
    function remember() { try { localStorage.setItem(KEY, '1'); } catch (e) {} }

    // Take ?from= / ?customer_posted= off the address, so a reload or a shared link doesn't repeat it.
    params.delete('from');
    params.delete('customer_posted');
    var rest = params.toString();
    try { history.replaceState(null, '', window.location.pathname + (rest ? '?' + rest : '')); } catch (e) {}

    function start() {
      var el = document.querySelector('[data-rebrand]');
      if (!el) return;
      var result = el.querySelector('[data-rebrand-result]');
      if (afterSignup && !result) return;      // another form's result, not ours
      if (!result && seen()) return;
      remember();
      el.hidden = false;
      var box = el.querySelector('.rebrand__box');
      if (box) box.focus({ preventScroll: true });

      function close() { el.hidden = true; }

      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-rebrand-close]')) { e.preventDefault(); close(); return; }
        if (e.target.closest('[data-rebrand-close-link]')) { close(); return; }
        var copy = e.target.closest('[data-rebrand-copy]');
        if (copy) {
          var code = el.querySelector('[data-rebrand-code]').textContent.trim();
          var done = function () { copy.textContent = copy.dataset.done; };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(done, function () { selectCode(); });
          } else {
            selectCode();
          }
        }
      });

      // Without clipboard access, select the code so it can be copied by hand.
      function selectCode() {
        var node = el.querySelector('[data-rebrand-code]');
        var range = document.createRange();
        range.selectNodeContents(node);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      }

      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

      // Back from the newsletter form: show its result.
      if (result) {
        var form = document.getElementById('rebrand-newsletter');
        if (form) form.scrollIntoView({ block: 'nearest' });
      }
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["review-text"] && !Shopify.designMode) return;
  try {
    (function () {
    // Show the toggle only when the text is longer than 5 lines (re-checked when the width changes).
    function check(box) {
      if (box.classList.contains('is-open')) return;
      var body = box.querySelector('.review-text__body');
      box.querySelector('.review-text__toggle').hidden = body.scrollHeight <= body.clientHeight + 1;
    }

    var observer = window.ResizeObserver
      ? new ResizeObserver(function (entries) {
          entries.forEach(function (entry) { check(entry.target.closest('[data-review-text]')); });
        })
      : null;

    function init(scope) {
      scope.querySelectorAll('[data-review-text]').forEach(function (box) {
        if (box.dataset.ready) return;
        box.dataset.ready = 'true';
        var toggle = box.querySelector('.review-text__toggle');
        toggle.addEventListener('click', function () {
          var open = box.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', String(open));
          toggle.textContent = open ? toggle.dataset.less : toggle.dataset.more;
        });
        check(box);
        if (observer) observer.observe(box.querySelector('.review-text__body'));
      });
    }

    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["soon-popup"] && !Shopify.designMode) return;
  try {
    // Opens the "Скоро наличен" popup from any [data-soon-popup] element.
  (function () {
    var lastFocus = null;
    function root() { return document.querySelector('[data-soon-popup-root]'); }

    function open() {
      var el = root();
      if (!el) return;
      lastFocus = document.activeElement;
      el.hidden = false;
      var box = el.querySelector('.soon-popup__box');
      if (box) box.focus({ preventScroll: true });
    }

    function close() {
      var el = root();
      if (!el || el.hidden) return;
      el.hidden = true;
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-soon-popup-close]')) { e.preventDefault(); close(); return; }
      if (e.target.closest('[data-soon-popup]')) { e.preventDefault(); open(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
